import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
// import algoliasearch from 'algoliasearch/lite'
import useAppState from 'utils/state'
import Icon from 'components/icon/icon'
import Backdrop from 'components/backdrop/backdrop'
import Sticky from 'react-stickynode'
import useWindowSize from 'utils/hooks/useWindowSize'
import groups from 'utils/data/groups'
import styles from './hits.module.scss'
import { cn, getRoute } from 'utils/helpers'
import { ALGOLIA_PRODUCT_INDEX } from 'utils/analytics/algolia'
import { MAX_MOBILE_WIDTH } from 'utils/vars'
import { urlToSearchState, createURL } from './url'
import useDelivery from './useDelivery'
import { InstantSearch, Configure, ScrollTo } from 'react-instantsearch-dom'

import searchClient from 'utils/search'
// const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY)

export default function LpHits({ account, filter, side, meta, children, onSearch }) {
    const { checkDelivery } = useDelivery()
    const [mobileShow, setMobileShow] = useState()
    const [personalization, setPersonalization] = useState()
    const router = useRouter()
    const { query } = router.query
    const [searchState, setSearchState] = useState(urlToSearchState(router))
    const { stateFilter, visitorId, loading } = useAppState()
    const { width } = useWindowSize()

    useEffect(() => {
        if (router.pathname == getRoute('suggestions')) {
            setPersonalization(stateFilter)
        }
    }, [stateFilter])

    let debouncedSetState
    const onSearchStateChange = state => {
        clearTimeout(debouncedSetState)
        debouncedSetState = setTimeout(() => {
            const newPath = createURL(state)
            if (router.asPath != newPath) {
                router.push(newPath, null, { scroll: false })
            }
        }, 700)
        setSearchState(state)
    }

    let filters = 'is_visible:true'
    if (account) {
        filters += ` && account_slug:${account}`
    } else {
        filters += ` && level:[1,2]`
    }
    if (filter) {
        filters += ` && ${filter}`
    }

    if (personalization) {
        if (personalization.price) {
            const priceOptions = {
                any_price: '',
                under_25: ' AND price_from <= 25',
                '25_50': ' AND price_from >= 25 AND price_from <= 50',
                '50_100': ' AND price_from >= 50 AND price_from <= 100',
                over_100: ' AND price_from >= 100'
            }
            filters += priceOptions[personalization.price]
        }
        if (personalization.group.length && personalization.group[0] != 'all') {
            const groupNames = groups
                .filter(g => personalization.group.indexOf(g.id) > -1)
                .map(g => `all_groups:"${g.name}"`)
            filters += ` AND (${groupNames.join(' OR ')})`
        }
        if (personalization.like) {
            filters += ` AND brand_like_${personalization.like} = 1`
        }
    }

    const hideFilterHandler = () => {
        setMobileShow(false)
    }

    const showFilterHandler = () => {
        setMobileShow(true)
    }

    if (loading) return null

    const defaultIndex = ALGOLIA_PRODUCT_INDEX//`${ALGOLIA_PRODUCT_INDEX}${coupon && coupon.code && !coupon.account_slug ? '_discount' : ''}`

    if (!visitorId) return <div style={{ minHeight: '75vh' }} />

    return (
        <>
            <div className={cn(styles.filterBtn, account && styles.filterBtnAccount)} onClick={showFilterHandler}>
                Filtras
            </div>
            <InstantSearch
                onSearchStateChange={onSearchStateChange}
                createURL={createURL}
                searchState={searchState}
                searchClient={searchClient}
                indexName={defaultIndex}
                stalledSearchDelay={400}
            >
                <ScrollTo>
                    <div id="hits" className={cn(styles.hits, 'mb72')}>
                        <Backdrop className={mobileShow && styles.backdropShow} onClick={hideFilterHandler} />
                        <div className={cn(styles.left, mobileShow && styles.mobileShow)}>
                            <Sticky enabled={width > MAX_MOBILE_WIDTH} top={30} bottomBoundary="#hits">
                                <div className={styles.leftContent}>
                                    <Icon
                                        icon="x"
                                        btn
                                        className={cn(styles.closeFilterBtn, 'tabletDesktopHide')}
                                        onClick={hideFilterHandler}
                                    />
                                    <Configure
                                        clickAnalytics
                                        filters={checkDelivery(filters)}
                                        query={query}
                                        hitsPerPage={48}
                                        enablePersonalization={false}
                                    />
                                    <div onClick={onSearch}>{side}</div>
                                </div>
                            </Sticky>
                        </div>
                        <div className={styles.right}>
                            {meta}
                            {children}
                        </div>
                    </div>
                </ScrollTo>
            </InstantSearch>
        </>
    )
}
